'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _FileTextOutlined = _interopRequireDefault(require('./lib/icons/FileTextOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _FileTextOutlined;
exports.default = _default;
module.exports = _default;